import { createGlobalStyle } from 'styled-components';
import { BryntumGanttGlobalStyles } from './components/bryntum-gantt';
import { DueDatePickerPopoverStyles } from './components/due-date-picker-popover';
import { PopconfirmStyles } from './components/popconfirm';

export const GlobalStyle = createGlobalStyle`
  /* NOTE:: Ant doesn't provide this as a variable overrides and the same class is not
  within the tooltip container and attaches itself to body by default. */
  .ant-tooltip-inner {
    /* padding: var(--spacing-03) var(--spacing-05); */
    font-size: 12px;
  }
  .ant-tooltip-arrow {
    display: none;
  }
  input[disabled], textarea[disabled] {
    -webkit-text-fill-color: var(--gray-100);
  }

  ${DueDatePickerPopoverStyles};
  ${PopconfirmStyles};
  ${BryntumGanttGlobalStyles};
`;
